import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_update_carriers_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { carriers: $frontendTypes.FootprintApiManager.input_update_carrier[] }): Promise<{ errors?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.carriers)) {
      $missingRequiredInParams.push('\'carriers\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/carriers/update`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

